<template>
  <div class="SA-slide view-slide">
    <img src="../../assets/images/seed-analyzer-bg.png">
    <div class="slide-text-part">
      <!-- <h3>Seed Analyzer</h3> -->
      <img src="../../assets/images/product-analyzer-logo.png"  v-on:click="select($event)">
      <span class="minimized-indicator">
        <div class="tooltip">
          <label class="opened">Opened</label>
          <label class="closed">Closed</label>
        </div>
      </span>
      <div class="clearfix"></div>
      <p>The power of Syngenta R&D at your fingertips...<br/>
      Product Analyzer gives resellers the ability to dive deep in to product performance displayed in a new creative way.  Having the ability to filter for geography, yield level, soils, etc. will bring confidence the right products are selected for valued customers.  
      </p>
      <div class="text-center">
        <button v-on:click="select($event)">OPEN APP</button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import baseAppComponent from "./baseAppComponent.vue";

export default {
  extends: baseAppComponent,
  name: "SeedAnalyzerComponent"
};
</script>

